var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.conflitoSelecionado
        ? _c("modal-visualizar-conflito", {
            attrs: { conflito: _vm.conflitoSelecionado },
            on: {
              closeModal: function($event) {
                _vm.conflitoSelecionado = null
              }
            }
          })
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: { configuracaoFiltro: {}, showfiltrosInformacoes: false },
            on: { pesquisar: _vm.search, limpar: _vm.handleLimpar }
          })
        ],
        1
      ),
      _c("app-listagem", {
        attrs: {
          "has-refresh-button": true,
          showButtonOrdemServico: false,
          showButtonAssinatura: false,
          "has-expansivel": false,
          "json-headers": _vm.colunas,
          "json-data": _vm.items,
          totalElements: _vm.totalElements,
          pagina: _vm.filtro.pagina,
          hasFiltroRapido: false,
          hasActionButton: _vm.showBotaoCadastrar(),
          typeActionButton: "primary",
          nameActionButton: "Cadastrar",
          sizeActionButton: "md",
          filtro: _vm.filtro,
          infoPrazos: false,
          headerLabel: "Listagem de processos com conflitos",
          showCsvButton: false
        },
        on: {
          atualizarFiltro: _vm.atualizarFiltro,
          updateListagem: _vm.search,
          changePage: _vm.changePage,
          sort: _vm.sort,
          executar: _vm.executar,
          click: _vm.novoConflito
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-475211b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475211b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ouvidoria/GestaoConflito.vue
// module id = null
// module chunks = 